import * as React from 'react';
import { useCallback } from 'react';
import { ICorpusDocument } from '../../../../models/ICorpusDocument';
import CorpuseDocumentIcon from './CorpuseDocumentIcon';

export type CorpuseDocumentItemProps = {
    url: string,
    name: string,
    id: string,
    mimeType: string,
    lineIdx: string,
    content?: string[],
    onClick: (document: ICorpusDocument, e: MouseEvent) => void
}


export function CorpuseDocumentItem({ url, name, id, mimeType, content, lineIdx, onClick }: CorpuseDocumentItemProps) {
    const onClickCb = useCallback((e) => {
        onClick({ id, name, url, content: content, mimeType, lineIdx }, e);
    }, [content, id, lineIdx, mimeType, name, onClick, url]);

    return <div className="corpus-document-item"
        onClick={onClickCb}>
        <span title={name}>
            <CorpuseDocumentIcon url={url} name={name} mimeType={mimeType} /> {name || url}
        </span>
        {url && <a className="corpus-document-item__url" href={url} rel="noreferrer" target="_blank" >
            <i className="icon icon-alan-stat-script-link" />
        </a>}
    </div>;
}
